// App-wide brand color as a JS value, for the places a Tailwind class can't reach:
// recharts props (fill/stroke), SVG attributes, and inline `style={{…}}`.
//
// WHY THIS EXISTS (and its limits): the brand blue #32B1FF appears ~600 times
// across the app. The MAJORITY are Tailwind arbitrary classes (`bg-[#32B1FF]`,
// `text-[#32B1FF]`, `border-t-[#32B1FF]`) — those CANNOT use this constant, because
// Tailwind's JIT extracts the literal hex string from source at build time; an
// interpolated class like `bg-[${BRAND_BLUE}]` silently fails to generate. For
// Tailwind classes use the `brand` theme color instead (`bg-brand`, `text-brand`,
// `bg-brand/10`), registered in tailwind.config.js. This module is ONLY for JS/chart/
// inline uses.
//
// Adoption is forward-looking: new code should import BRAND_BLUE here rather than
// re-typing "#32B1FF"; existing literals are left in place (identical value).

export const BRAND_BLUE = "#32B1FF";

export default BRAND_BLUE;
